exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.red {\n  color: red;\n}\n\n.green {\n  color: green;\n}\n\ndiv.page-header button {\n  margin-right:10px;\n}\n\n.add-filter-group-form div.row {\n  padding-bottom: 15px;\n}\n\nspan.badge {\n  margin-right: 0.25rem;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/filter-groups/styles.css
// module id = 2068
// module chunks = 29